import { render, staticRenderFns } from "./PublishingContractsSplitEditDialog.vue?vue&type=template&id=167728ee&scoped=true"
import script from "./PublishingContractsSplitEditDialog.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSplitEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PublishingContractsSplitEditDialog.vue?vue&type=style&index=0&id=167728ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167728ee",
  null
  
)

export default component.exports